import React, { MouseEventHandler } from 'react';
import { PencilAltIcon } from '@heroicons/react/solid';
export interface ICancelFormButtonProps {
  hasChanges?: boolean;
  disabled?: boolean;
  label?: string;
  onCleanUp?: () => void;
  onClick?: () => void;
}

const CancelFormButton: React.FC<ICancelFormButtonProps> = ({
  onClick,
  onCleanUp,
  label = 'Cancel',
  hasChanges,
  disabled,
}) => {
  const resetAction = (hasChanges: boolean | undefined) => () => {
    hasChanges ? onCleanUp?.() : onClick?.();
  };
  return (
    <button
      onClick={resetAction(hasChanges)}
      type="button"
      disabled={disabled}
      className="inline-flex bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
    >
      {label}
      {hasChanges && (
        <PencilAltIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
      )}
    </button>
  );
};

export default CancelFormButton;
